module.exports = __webpack_public_path__ + "img/jornay-logo-mobile.a1d61593.svg";